import { useQuery } from '@tanstack/react-query';
import apiClient from 'shared/api/client.js';
import { groupProductRowsById } from '../utils/groupProductRows.js';

// GET /catalog/products?search=&categoryId= — sales-safe product search
// (no cost fields, see routes/catalogRoutes.js). Used two ways in this
// workspace:
//   1. `useCatalogProducts()` with no args — the whole active catalog, used
//      to hydrate a matched line's product name/tier prices from its
//      `matched_product_id` (request_lines carries the id but not the
//      product's name/price — there is no by-id product-detail endpoint in
//      this API surface, see this task's final report).
//   2. `useCatalogProducts({ search })` — the manual product picker's
//      search-as-you-type results, for an unmatched or misidentified line.
// Both share this one hook; TanStack Query caches them under distinct keys.
export function useCatalogProducts({ search, categoryId } = {}) {
  return useQuery({
    queryKey: ['catalog', 'products', search ?? null, categoryId ?? null],
    queryFn: () => apiClient.get('/catalog/products', { search, categoryId }),
    select: (data) => groupProductRowsById(data.products),
    staleTime: 60 * 1000,
  });
}

export default useCatalogProducts;
